import { createAppContainer } from "react-navigation";
import { createStackNavigator } from "react-navigation-stack";
import HomeScreen from "./src/screens/HomeScreen";
import AddScreen from "./src/screens/AddScreen";
import AddSubScreen from "./src/screens/AddSubScreen";
import MulScreen from "./src/screens/MulScreen";
import DivScreen from "./src/screens/DivScreen";
import SquareRootScreen from "./src/screens/SquareRootScreen";
import CubeRootScreen from "./src/screens/CubeRootScreen";
import SquareScreen from "./src/screens/SquareScreen";
import CubeScreen from "./src/screens/CubeScreen";
import DecimalAdditionScreen from "./src/screens/DecimalAdditionScreen";
import DecimalAddSubScreen from "./src/screens/DecimalAddSubScreen";
import TableScreen from "./src/screens/TableScreen";
import PercentageScreen from "./src/screens/PercentageScreen";
import IntroScreen from "./src/screens/IntroScreen";
import WebsiteScreen from "./src/screens/WebsiteScreen";
import ShareScreen from "./src/screens/ShareScreen";
import StopWatchScreen from "./src/screens/StopWatchScreen";
import CalculatorScreen from "./src/screens/CalculatorScreen";
import YoutubeScreen from "./src/screens/YoutubeScreen";
import TimerScreen from "./src/screens/TimerScreen";
import AddSubNegScreen from "./src/screens/AddSubNegScreen";
import DecimalDivScreen from "./src/screens/DecimalDivScreen";
import DecimalMulScreen from "./src/screens/DecimalMul";
import MixAddSubScreen from "./src/screens/MixAddSubScreen";
import TablePracticeScreen from "./src/screens/TablePracticeScreen";
import MemoScreen from "./src/screens/MemoScreen";

const navigator = createStackNavigator(
  {
    Memo: MemoScreen,
    TablePractice: TablePracticeScreen,
    MixAddSub: MixAddSubScreen,
    DecimalMul: DecimalMulScreen,
    DecimalDiv: DecimalDivScreen,
    AddSubNeg: AddSubNegScreen,
    Share: ShareScreen,
    Home: HomeScreen,
    Add: AddScreen,
    AddSub: AddSubScreen,
    Mul: MulScreen,
    Div: DivScreen,
    SquareRoot: SquareRootScreen,
    CubeRoot: CubeRootScreen,
    Square: SquareScreen,
    Cube: CubeScreen,
    DecimalAddition: DecimalAdditionScreen,
    DecimalAddSub: DecimalAddSubScreen,
    Table: TableScreen,
    Percentage: PercentageScreen,
    Intro: IntroScreen,
    Website: WebsiteScreen,
    StopWatch: StopWatchScreen,
    Calculator: CalculatorScreen,
    Youtube: YoutubeScreen,
    Timer: TimerScreen,
  },
  {
    initialRouteName: "Home",
    headerStyle: {
      backgroundColor: "red",
    },
    defaultNavigationOptions: {
      title: "Kidz Brain Academy",
      headerTitleStyle: {
        textAlign: "center",
        flex: 1,
        color: "black",
        fontSize: 30,
        fontWeight: "bold",
      },
    },
  }
);

export default createAppContainer(navigator);
